import { MENU_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';
import { createPageEntryPoint } from '@atlassian/jira-create-route-entry-point/src/index.tsx';
import { ideasEntryPoint } from '@atlassian/jira-spa-apps-polaris-ideas/entrypoint.tsx';

export const ideasPageEntryPoint = createPageEntryPoint({
	main: ideasEntryPoint,
	topNavigationMenuId: MENU_ID.PROJECTS,
});
